import {useCallback, useContext} from 'react';
import {useSelector, useStore} from 'react-redux';
import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';
import {useModals} from '~/common/FabricInvitation/EventCreateDesign/components/NavBottom/hooks/useModals';
import {useNavigation} from '~/common/FabricInvitation/EventCreateDesign/components/NavBottom/hooks/useNavigation';
import {useNavigator} from '~/common/FabricInvitation/EventCreateDesign/components/NavBottom/hooks/useNavigator';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {
  selectCurrentSection,
  selectPremiumFeaturesPristine,
  selectSavingStep,
  selectUsedPremiumFeature,
} from '~/common/fabric/reducers/fabricDesign/selectors';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';

export const useNavBottomState = () => {
  const store = useStore();
  const {canvas} = useContext(EventCreateContext);
  const currentRoute = useCurrentRoute();
  const isLargishAndUp = useIsLargishAndUp();

  const usedPremiumFeature = useSelector(selectUsedPremiumFeature);
  const premiumFeaturesPristine = useSelector(selectPremiumFeaturesPristine);
  const savingStep = useSelector(selectSavingStep);
  const currentSection = useSelector(selectCurrentSection);

  const navigate = useNavigator({
    isMobile: !isLargishAndUp,
    disableAutoOpenEditor: currentSection === Sections.CARD_DESIGN,
  });

  const {
    showUpsellModal,
    showExitPremiumPreviewModal,
    setShowUpsellModal,
    setShowExitPremiumPreviewModal,
    upgradeToPremium,
    downgradeBackToBasic,
    handleShowUpsell,
  } = useModals({navigate});

  const {handleNavigation: navigationHandler, continueNavigation} = useNavigation({
    store,
    canvas,
    currentRoute,
    usedPremiumFeature,
    premiumFeaturesPristine,
    handleShowUpsell,
  });

  const upgradeAndContinue = useCallback(async () => {
    upgradeToPremium();
    await continueNavigation();
  }, [upgradeToPremium, continueNavigation]);

  const handleCloseUpsell = useCallback(() => {
    setShowUpsellModal(false);
    setShowExitPremiumPreviewModal(true);
  }, [setShowUpsellModal, setShowExitPremiumPreviewModal]);

  const handleCloseExitPreview = useCallback(() => {
    setShowExitPremiumPreviewModal(false);
  }, [setShowExitPremiumPreviewModal]);

  const handleModals = {
    handleCloseUpsell,
    handleCloseExitPreview,
    upgradeAndContinue,
    downgradeBackToBasic,
    toggleUpsellModal: () => setShowUpsellModal(!showUpsellModal),
  };

  return {
    showUpsellModal,
    showExitPremiumPreviewModal,
    savingStep,
    handleNavigation: navigationHandler,
    handleModals,
  };
};
